module.exports = __webpack_public_path__ + "static/media/Vec vectores_TC amarillo.eb7447ee.svg";